import React, { useState, useEffect } from "react";
import InputWithLabel from "./InputWithLabel";
import Button from "../buttons/button";
import SelectBox from "./SelectBox ";
import { useGetWorkingAreasQuery } from "../../../app/globalApi";
import moment from "moment";
import { capitalize } from "../../../helpers/Utils";
import useTranslator from "../../../hooks/useTranslator";

const initialFormData = {
  employee_name: "",
  employee_doj: "",
  working_area_id: "",
  employee_role_id: "",
};

const today = moment().format("YYYY-MM-DD");

const EmployeeFilter = ({ onApplyFilter, date, onClose }) => {
  const [filtersData, setFiltersData] = useState(initialFormData);
  const [roleList, setRoleList] = useState([]);
  const { data: workingAreas } = useGetWorkingAreasQuery();
  const { _t } = useTranslator();

  useEffect(() => {
    setFiltersData((prev) => ({
      ...prev,
      employee_role_id: "",
    }));
    if (workingAreas !== "") {
      if (filtersData.working_area_id) {
        const selectedArea = workingAreas?.data?.find(
          (area) => area.id === parseInt(filtersData.working_area_id)
        );
        const filteredRoles = selectedArea ? selectedArea.roles : [];
        setRoleList(filteredRoles);
      } else {
        setRoleList([]);
      }
    }
  }, [workingAreas, filtersData?.working_area_id]);

  const handleChange = (e) => {
    setFiltersData({ ...filtersData, [e.target.name]: e.target.value });
  };

  const handleReset = (e) => {
    e.preventDefault();
    setFiltersData(initialFormData);
    onApplyFilter(initialFormData);
    if (onClose) {
      onClose();
    }
  };

  const handleApply = (e) => {
    e.preventDefault();
    onApplyFilter({ ...filtersData });
    if (onClose) {
      onClose();
    }
  };

  return (
    <div className="dropdown_body">
      <h5 className="mb-3 border-bottom">{_t("filter", "Filter")}</h5>

      <InputWithLabel
        label={_t("employee_name", "Employee Name")}
        type="text"
        name="employee_name"
        value={filtersData.employee_name}
        onChange={handleChange}
        placeholder={_t("employee_name_placeholder", "Employee Name...")}
      />
      <InputWithLabel
        label={_t("employee_doj", "Date of Join")}
        type="date"
        name="employee_doj"
        value={filtersData.employee_doj}
        onChange={handleChange}
        max={today}
      />
      <SelectBox
        label={_t("working_area", "Working Area")}
        name="working_area_id"
        value={filtersData.working_area_id}
        onChange={handleChange}
        options={workingAreas?.data
          .filter(
            (workingArea) => workingArea?.name?.toLowerCase() != "manager"
          )
          ?.map((list) => ({
            value: list.id,
            label: _t(list.name, list.name),
          }))}
      />
      <SelectBox
        label={_t("role", "Role")}
        name="employee_role_id"
        value={filtersData.employee_role_id}
        onChange={handleChange}
        options={roleList?.map((list) => ({
          value: list.id,
          label: _t(capitalize(list.name),capitalize(list.name)),
        }))}
        disabled={filtersData.working_area_id === ""}
      />
       <div className="d-flex justify-content-between mt-3">
        <Button onClick={handleReset} label={_t("reset", "Reset")} className="reset_btn" />
        <Button className="cmn_btn" label={_t("apply", "Apply")} onClick={handleApply} />
      </div>
    </div>
  );
};

export default EmployeeFilter;
